import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { delay, map, takeUntil } from 'rxjs/operators';

import { EventTypes } from '../../../../core/constants/event-types';
import { BaseIndexPageComponent } from './base-index-page.component';

@Component({
    selector: 'app-base-tree-table-page',
    template: ``,
    standalone: false
})
export abstract class BaseTreeTablePageComponent
  extends BaseIndexPageComponent
  implements OnDestroy, OnInit
{
  //#region properties

  @Input() querySelectorPrefix: string = '';
  eventType: EventTypes;

  //#endregion

  ngOnInit() {
    super.ngOnInit();
  }

  changeParentSubItems(
    id: number,
    subItems: any[],
    nodeBtnElement?: HTMLElement
  ): Observable<any[]> {
    return of(this.items).pipe(
      map((items) => {
        let selectedItem: any;

        const findItem = (items: any[]) =>
          items.forEach((item) => {
            if (item.id == id) {
              selectedItem = item;
              //if sub items is exist
              if (subItems?.length) {
                // increase the total number
                // subItems.forEach((subItem) => {
                //   if (!this.isExistPhonebook(subItem.id))
                //     this.paginationModel.totalCount =
                //       this.paginationModel.totalCount + 1;
                // })
                item.subItems = subItems;
              } // if sub items not exist > remove btn element
              else this.removeNodeBtnElement(nodeBtnElement, id);
            }
            if (!selectedItem && item?.subItems?.length)
              findItem(item?.subItems);
          });

        findItem(this.items);
        return items;
      })
    );
  }

  defaultSelectTreeItem() {
    try {
      interval(500)
        .pipe(delay(500), takeUntil(this.items$))
        .subscribe(
          (second) => {},
          (item) => {},
          () => {
            document
              .querySelectorAll(
                `.${this.querySelectorPrefix}container [data-id]`
              )[0]
              ?.classList?.add('row-active');
          }
        );
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#region node btn

  onClickNodeBtn(treeElement, parentId) {
    try {
      //change node btn design
      treeElement.classList.toggle('mdi-plus');
      treeElement.classList.toggle('text-success');
      treeElement.classList.toggle('bg-light-success');
      treeElement.classList.toggle('mdi-minus');
      treeElement.classList.toggle('text-danger');
      treeElement.classList.toggle('bg-light-danger');

      //get all elements
      const treeElements = document.querySelectorAll(
        `.${this.querySelectorPrefix}container [data-id]`
      );

      //show Children
      treeElements.forEach((element) => {
        if (element.getAttribute('data-parentid') == parentId)
          element.classList.toggle('d-none');
      });

      //#region اگر والد بسته شد تمامی فرزندان بسته شوند
      if (treeElement.classList.contains('mdi-minus')) return;

      treeElements.forEach((child) => {
        const ParentId = child.getAttribute('data-parentid');

        //#region close all children by parent
        treeElements.forEach((parent) => {
          if (parent.getAttribute('data-id') == ParentId) {
            //اگر والد بسته بود فرزندم بسته شود
            if (parent.classList.contains('d-none')) {
              child.classList.add('d-none');
              return;
            }
          }
        });
        //#endregion

        //#region change style tree btn
        //اگر ایتمی بسته بود ایکونشم تغییر کنه
        if (child.classList.contains('d-none')) {
          let treeBtn = child.querySelector('.menu-btn');
          if (!treeBtn) return;
          treeBtn?.classList?.remove('mdi-minus');
          treeBtn?.classList?.remove('text-danger');
          treeBtn?.classList?.remove('bg-light-danger');
          treeBtn?.classList?.add('mdi-plus');
          treeBtn?.classList?.add('text-success');
          treeBtn?.classList?.add('bg-light-success');
        }

        //#endregion
      });

      //#endregion
    } catch (error) {
      this.loggerService.logError(this.tagName, error, this.eventType);
    }
  }

  removeNodeBtnElement(nodeBtnElement: HTMLElement, nodeId: number) {
    if (!nodeBtnElement) return;
    this.changeNodeBtnLoading(nodeBtnElement, nodeId, false);
    nodeBtnElement.remove();
  }

  changeNodeBtnLoading(nodeBtnElement: HTMLElement, id: number, loading) {
    if (!nodeBtnElement) return;
    if (loading) {
      const loadingElement = `
      <div class="tw-w-[25px]">
      <span class="spinner-border spinner-border-sm tw-p-2  tw-text-2xl text-primary" role="status" aria-hidden="true" data-loading-id=${id}>
      </span>
      </div>
      `;
      nodeBtnElement.insertAdjacentHTML('afterend', loadingElement);
      nodeBtnElement.classList.toggle('d-none');
    } else {
      var loadingElements = document.querySelectorAll(
        `.${this.querySelectorPrefix}container [data-loading-id]`
      );
      if (loadingElements?.length)
        loadingElements.forEach((element) => {
          if (+element.getAttribute('data-loading-id') == id) element.remove();
        });
      nodeBtnElement.classList.toggle('d-none');
    }
  }
  //#endregion
}
